module.exports = __webpack_public_path__ + "img/217-virgin-islands.5c4674aa.svg";